module.exports = __webpack_public_path__ + "image/jicai_docs_1.0dd30a4.png";